module.exports = __webpack_public_path__ + "img/icon_phone_24.ab0b2f90.svg";